// extracted by mini-css-extract-plugin
export default {"spanBlock":"SuperEditableSpan_spanBlock__bq8We","span":"SuperEditableSpan_span__f1tUW","input":"SuperEditableSpan_input__JfPpA","pen":"SuperEditableSpan_pen__SCViJ"};